"use client"

import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { BarChart3, Share2 } from "lucide-react"
import { useTranslation } from "react-i18next"

interface AnalyticsEmptyStateProps {
  onEnableSharing: () => void
}

export function AnalyticsEmptyState({ onEnableSharing }: AnalyticsEmptyStateProps) {
  const { t } = useTranslation("analytics")
  return (
    <Card>
      <CardContent className="py-16 text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
          <BarChart3 className="h-8 w-8 text-muted-foreground" />
        </div>
        <h3 className="mb-2 text-xl font-semibold">{t("analytics:analyticsTableView.empty.notAvailable")}</h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          {t("analytics:analyticsTableView.empty.enablesharing")}
        </p>
        <Button onClick={onEnableSharing} className="gap-2">
          <Share2 className="h-4 w-4" />
          {t("analytics:analyticsTableView.empty.enablesharingBtn")}
        </Button>
      </CardContent>
    </Card>
  )
}
